namespace e5.ScrollViewLimit {
    class ScrollViewLimitCover implements IScrollViewLimit {
        public getMinX(view: ScrollView, scale: number = view.scale): number {
            var rw = view.contentWidth * scale;
            if (rw < view.width) {
                return 0;
            }
            return view.width - view.contentWidth * scale;
        }

        public getMaxX(view: ScrollView, scale: number = view.scale): number {
            var rw = view.contentWidth * scale;
            if (rw < view.width) {
                return view.width - rw;
            }
            return 0;
        }

        public getMinY(view: ScrollView, scale: number = view.scale): number {
            var rh = view.contentHeight * scale;
            if (rh < view.height) {
                return 0;
            }
            return view.height - view.contentHeight * scale;
        }

        public getMaxY(view: ScrollView, scale: number = view.scale): number {
            var rh = view.contentHeight * scale;
            if (rh < view.height) {
                return view.height - rh;
            }
            return 0;
        }
    }

    export const Cover = new ScrollViewLimitCover();
}